import renderRecaptchaWidget from '@/google-recaptcha/renderRecaptchaWidget';

/**
 * @module google-recaptcha/renderRecaptchaWidgetOnVisible
 * @description
 * Работаем с Intersection Ovserver API.
 * Отслеживаем элемент с data-атрибутом в зоне видимости, и только тогда вызываем рендер капчи для конкретной формы.
 * @param {object} context - контекст
 * @param {DOMElement} recaptcha_block - блок для рендера рекапчи
 * @param {string} formType - тип формы
 *
 * @returns {void}
 */
export default (context, recaptcha_block, formType = '') => {
  let isInvisible = false;

  if (recaptcha_block.dataset.recaptchaType === 'invisible') {
    isInvisible = true;

    recaptcha_block.dataset.size = 'invisible';

    if (!recaptcha_block.dataset.badge) {
      recaptcha_block.dataset.badge = 'bottomleft';
    }

    let recaptchaTypeInput = document.createElement('input');
    recaptchaTypeInput.type = 'hidden';
    recaptchaTypeInput.name = 'recaptcha_type';
    recaptchaTypeInput.value = 'invisible';

    recaptcha_block.after(recaptchaTypeInput);
  }

  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  };

  let renderReCaptchaCallback = (entries) => {
    window.EventBus.subscribe('recaptcha:insales:loaded', () => {
      try {
        if (entries[0].isIntersecting && entries[0].target.children.length === 0) {
          renderRecaptchaWidget(recaptcha_block, formType, context, isInvisible);
        }
      } catch (catchErrorMessage) {
        if (window.reCaptchaCommon) {
          // В случае ошибки пробуем фоллбек
          window.reCaptchaCommon.render(recaptcha_block, formType, context);
        } else {
          console.warn('grecaptcha error', catchErrorMessage);
        }
      }
    });
  };

  const observer = new IntersectionObserver(renderReCaptchaCallback, options);
  let target = recaptcha_block;

  observer.observe(target);
};
